export enum MenuSelectedPuestosEnum {
  razonsocial = "razonsocial",
  sucursales = "sucursales",
  puestos = "puestos",
}
export interface ActionMenuPuestosSelected {
  payload: MenuSelectedPuestosEnum;
}
